module.exports = __webpack_public_path__ + "static/media/footer-support.54e48961.svg";